import React from 'react'
import { func } from 'prop-types'
import styled from 'styled-components'

import { greyDark } from 'styles/colors'
import { fontWeights, fontSizes } from 'styles/typography'
import * as spacing from 'styles/spacing'
import Icon from 'components/Icon'

import LeftArrow from 'icons/left-arrow.svg'

export const Back = styled.button`
  position: absolute;
  top: 60px;
  left: ${spacing.large};
  display: flex;
  align-items: center;
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  color: ${greyDark};
`

const MobileBack = ({ onClick }) => {
  return (
    <Back className="u-hide-medium-up" onClick={onClick}>
      <Icon icon={<LeftArrow />} />
    </Back>
  )
}

MobileBack.propTypes = {
  onClick: func.isRequired
}

export default MobileBack
